import React, { useContext } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import {
  Box,
  Button,
  ButtonBase,
  Container,
  Grid,
  Link,
  Typography
} from "@mui/material";
import Hero from "../../components/layout/Hero";
import {
  BCPSearch,
  BCPArrowRightFromBracket
} from "../../components/icons/bcp/BCPIcons";
import HighlightedEvents from "../../components/utilities/HighlightedEvents";
import FeaturedEvents from "../../components/utilities/FeaturedEvents";
import PostGallery from "../../components/utilities/PostGallery";
import { getEnvironmentVariable } from "../../global/environmentVariables";
const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);
const getAppLinks = () => {
  let appLinks = {};
  if (
    getEnvironmentVariable("APP_LINKS") !== undefined &&
    getEnvironmentVariable("APP_LINKS") !== "NOT SET"
  ) {
    try {
      appLinks = JSON.parse(getEnvironmentVariable("APP_LINKS"));
    } catch (err) {}
  }
  return appLinks;
};

export default function HomeWarmachine() {
  const authContext = useContext(AuthContext);
  return (
    <>
      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/header.jpg`}
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "600px"],
          minHeight: "unset",
          color: "common.white"
        }}
      >
        <Typography variant="h1" align="left" color="inherit" paragraph>
          Narrative & Hobby Events.
        </Typography>
        <Box sx={{ marginBottom: 4 }}>
          <Grid container spacing={2} justifyContent="left">
            <Grid item>
              <Button
                href="/play/events"
                variant="contained"
                color="primary"
                startIcon={<BCPSearch />}
              >
                Find an Event
              </Button>
            </Grid>
            {!authContext?.authState?.isAuthenticated ? (
              <Grid item>
                <Button
                  href="/login"
                  variant="outlined"
                  color="secondary"
                  startIcon={<BCPArrowRightFromBracket />}
                  sx={{ backgroundColor: "common.white" }}
                >
                  Login
                </Button>
              </Grid>
            ) : (
              <Grid item>
                <Button
                  focusRipple
                  href="/subscription"
                  variant="contained"
                  color="success"
                >
                  Subscribe
                </Button>
              </Grid>
            )}
          </Grid>
        </Box>
        <Box sx={{ marginBottom: 4 }}>
          <Grid container spacing={2} justifyContent="left">
            {getAppLinks()?.player?.apple && (
              <Grid item>
                <ButtonBase
                  focusRipple
                  style={{
                    width: "150px"
                  }}
                  href={getAppLinks().player.apple}
                  target="_blank"
                  aria-label={`View app in Apple App Store.`}
                >
                  <span
                    style={{
                      width: "150px",
                      height: "44px",
                      backgroundSize: "150px 44px",
                      backgroundRepeat: "no-repeat",
                      backgroundImage: `url(${SYSTEM_IMAGES_CLOUDFRONT}/system-images/apple.png)`
                    }}
                  />
                </ButtonBase>
              </Grid>
            )}
            {getAppLinks().player?.google && (
              <Grid item>
                <ButtonBase
                  focusRipple
                  style={{
                    width: "150px"
                  }}
                  href={getAppLinks().player.google}
                  target="_blank"
                  aria-label={`View app in Google Play Store.`}
                >
                  <span
                    style={{
                      width: "150px",
                      height: "44px",
                      backgroundSize: "150px 44px",
                      backgroundRepeat: "no-repeat",
                      backgroundImage: `url(${SYSTEM_IMAGES_CLOUDFRONT}/system-images/google.png)`
                    }}
                  />
                </ButtonBase>
              </Grid>
            )}
          </Grid>
        </Box>
      </Hero>
      <FeaturedEvents />
      <HighlightedEvents />
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid container spacing={1} sx={{ p: 1, mb: 2 }}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              News
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <PostGallery
              searchLimit={6}
              doPaging={false}
              loadMoreHref="/news"
            />
          </Grid>
        </Grid>
      </Container>
      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/section1.jpg`}
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          color: "common.black"
        }}
        maxWidth="md"
      >
        <Grid container>
          <Grid item xs={12} md={6} lg={8}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              For Players
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              The Best Coast Pairings player app for iOS and Android is a
              player's connection to competitive events. Using the Player App
              you can search for, browse through and register for events. Also,
              see table assignments and pairings and view placings for any
              ongoing events. Players who are participating in the event can
              securely check in and remotely score as well as see any submitted
              lists at the event.
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              <Link
                href={
                  authContext?.authState?.identity?.subscriber
                    ? "/account"
                    : "/subscription/player"
                }
                underline="none"
                sx={{
                  color: "green"
                }}
              >
                Subscribe
              </Link>{" "}
              and see any submitted list, deck or crew for any event world wide
              and get exclusive discounts and rewards.
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={4}
            sx={{
              pt: [1, 1, 12]
            }}
          >
            <Box sx={{ marginBottom: 4 }}>
              <Grid
                container
                spacing={2}
                sx={{
                  justifyContent: ["center", "center", "right"]
                }}
              >
                {getAppLinks().player?.apple && (
                  <Grid item xs={12}>
                    <ButtonBase
                      focusRipple
                      style={{
                        width: "150px"
                      }}
                      href={getAppLinks().player.apple}
                      target="_blank"
                      aria-label={`View app in Apple App Store.`}
                    >
                      <span
                        style={{
                          width: "150px",
                          height: "44px",
                          backgroundSize: "150px 44px",
                          backgroundRepeat: "no-repeat",
                          backgroundImage: `url(${SYSTEM_IMAGES_CLOUDFRONT}/system-images/apple.png)`
                        }}
                      />
                    </ButtonBase>
                  </Grid>
                )}
                {getAppLinks().player?.google && (
                  <Grid item xs={12}>
                    <ButtonBase
                      focusRipple
                      style={{
                        width: "150px"
                      }}
                      href={getAppLinks().player.google}
                      target="_blank"
                      aria-label={`View app in Google Play Store.`}
                    >
                      <span
                        style={{
                          width: "150px",
                          height: "44px",
                          backgroundSize: "150px 44px",
                          backgroundRepeat: "no-repeat",
                          backgroundImage: `url(${SYSTEM_IMAGES_CLOUDFRONT}/system-images/google.png)`
                        }}
                      />
                    </ButtonBase>
                  </Grid>
                )}
                {!authContext?.authState?.identity?.subscriber && (
                  <Grid item xs={12}>
                    <Button
                      focusRipple
                      style={{
                        width: "150px",
                        height: "44px"
                      }}
                      href="/subscription/player"
                      variant="contained"
                      color="success"
                    >
                      Subscribe
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Hero>
      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/section2.jpg`}
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          color: "common.white"
        }}
        maxWidth="md"
      >
        <Grid container>
          <Grid item xs={12} md={6} lg={8}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              For Tournament Organizers
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              The Best Coast Pairings Tournament Organizer for iOS (testing for
              Android) is the easiest way to run your gaming event. Currently,
              the TO App offers support for over 15 of your favorite game
              systems such as Warhammer 40k, Xwing and Magic. This free software
              provides a TO with everything they need to run their event easily
              including: online registration, pairings, placings and rankings.
              Even opt for online ticket sales for a small charge per ticket.
              This revolutionary tool makes it easy to be a TO for any system
              giving you more time to judge and have fun.
            </Typography>
          </Grid>
        </Grid>
      </Hero>
      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/section3.jpg`}
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          color: "common.black"
        }}
        maxWidth="md"
      >
        <Grid container>
          <Grid item xs={12} md={6} lg={8}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              For Retailers, Conventions {"&"} League Organizers
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              Event Suite by Best Coast Pairings is the ultimate tool to run
              your large multi game events, leagues and retail events. Create
              and manage custom leagues and rankings for your location and
              administer which TOs can create events. Administrators can use one
              payment account for multiple TOs and discounted ticketing fees.
              Additionally event suite provides a location website or iframe
              support for your own site to display your leagues and rankings.
              For more information contact{" "}
              <Link href="mailto:support@bestcoastpairings.com" color="inherit">
                support@bestcoastpairings.com
              </Link>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={4}
            sx={{
              pt: [1, 1, 12]
            }}
          >
            <Box sx={{ marginBottom: 4 }}>
              <Grid
                container
                spacing={2}
                sx={{
                  justifyContent: ["center", "center", "right"]
                }}
              >
                <Grid item xs={12}>
                  <Button
                    focusRipple
                    style={{
                      width: "150px",
                      height: "44px"
                    }}
                    href="/subscription/circuit-suite"
                    variant="contained"
                    color="success"
                  >
                    Subscribe
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Hero>
    </>
  );
}
